import { rootSlice } from "../createRootSlice";
import { muiDataGridStarted } from "../apiutils";
const WHITELIST_BASE = "whitelist";
const API_TAG = "Whitelist";
const API_TAG_SINGLE = "WhitelistSingle";

export const whitelistSlice = rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getWhitelists: builder.query({
            query: ({ args, invalidate }) => ({
                url: `/${WHITELIST_BASE}?page=${args.page}&size=${args.size}`,
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getWhitelists', 'Whitelist')
        }),
        getWhitelist: builder.query({ 
            query: (id) => ({ 
                url: `/${WHITELIST_BASE}/${id}`, 
                method: 'GET', 
            }),
            providesTags: (id) => [{ type: API_TAG_SINGLE, id }],
        }),
        createWhitelist: builder.mutation({ 
            query: (whitelist) => ({ 
                url: `/${WHITELIST_BASE}/new`, 
                method: 'POST', 
                body: whitelist
            }),
            invalidatesTags: () => [
                { type: API_TAG }
            ],
        }),
        editWhitelist: builder.mutation({ 
            query: (whitelist) => ({ 
                url: `/${WHITELIST_BASE}/${whitelist.id}`, 
                method: 'PUT', 
                body: whitelist
            }),
            invalidatesTags: (whitelist) => [
                { type: API_TAG },
                { type: API_TAG_SINGLE, id: whitelist.id }
            ],
        }),
        getWhitelistsSelect: builder.query({
            query: () => ({
                url: `/${WHITELIST_BASE}`,
                method: 'GET',
            }),
            providesTags: () => [{ type: API_TAG }],
        }),
        deleteWhitelist: builder.mutation({ 
            query: (id) => ({ 
                url: `/${WHITELIST_BASE}/${id}`, 
                method: 'DELETE', 
            }),
            invalidatesTags: (id) => [
                { type: API_TAG},
                { type: API_TAG_SINGLE, id }
            ],
        }),
        checkWhitelistLogin: builder.query({
            query: () => ({
                url: `/${WHITELIST_BASE}/check`,
                method: 'GET',
            }),
            providesTags: () => [{ type: API_TAG }],
        }),
    }),
});

export const { 
    useGetWhitelistsQuery, 
    useGetWhitelistQuery, 
    useCreateWhitelistMutation, 
    useEditWhitelistMutation, 
    useGetWhitelistsSelectQuery, 
    useDeleteWhitelistMutation,
    useCheckWhitelistLoginQuery
} = whitelistSlice;
